module.exports = {
      id: "google-g-usage",
      viewBox: "0 0 46 46",
      url: "/" + "sprite-819208feb9a4c8de23db7726a2e05315.svg#google-g",
      toString: function () {
        return this.url;
      }
    }